import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

class DialogSuccess extends React.Component {
  handlePayment = () => {
    const { data, onPayment } = this.props;

    if (data.orderId && data.key_id) {
      if (onPayment) {
        onPayment(data);
      } else {
        this.navigateToJoyRide(data.paymentlink);
      }
    } else if (data.paymentlink) {
      this.navigateToJoyRide(data.paymentlink);
    }
  };

  navigateToJoyRide = (paymentlink) => {
    window.open(paymentlink);
    window.location.href = this.props.returnUrl || "/joy-rides";
  };

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    const { open, data, block } = this.props;
    const { bookingId } = data;
    return (
      <Dialog
        open={open}
        onClose={this.handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" style={{ minWidth: "400px" }}>
          <span style={{ color: "green" }}>Booking Succesful</span>
          <span> (Booking ID : {bookingId})</span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {block
              ? "Please complete the payment in the next 10 minutes."
              : "We have confirmed your seats for the next 10 minutes."}
            <br />
            Proceed to complete payment.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handlePayment} color="primary">
            Proceed to Payment
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default DialogSuccess;
